var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#DDF781"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3) scale(0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3667 12.6333L10.7 7.6L14.0667 3.93333L13.1 2.96667L6.8 10.2667L4.93333 8.4L11.2 1.1C11.7333 0.566667 12.3611 0.3 13.0833 0.3C13.8056 0.3 14.4333 0.566667 14.9667 1.1L15.9333 2.06667L17.6 0.4C17.8667 0.133333 18.1833 0 18.55 0C18.9167 0 19.2333 0.133333 19.5 0.4L22.6 3.5C22.8667 3.76667 23 4.08333 23 4.45C23 4.81667 22.8667 5.13333 22.6 5.4L15.3667 12.6333ZM5 24H0.666667V19L9.46667 9.5L14.5 14.5L5 24Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.36fc39a539c1dfcad35c54b2c50dd37a.svg";
export { ForwardRef as ReactComponent };